const ResponseStatus = {
    SUCCESS: {
        value: "success"
    },
    ERROR: {
        value: "error"
    },
    isSuccess: (response) => {
        return response.status == ResponseStatus.SUCCESS.value
    },
    isError: (response) => {
        return response.status == ResponseStatus.ERROR.value
    },
}

export default ResponseStatus